import styles from './Arrow.module.scss'

export const PreviewArrow = ({ currentSlide, slideCount, arrowLocation, ...props }) => {
  return(
  
    <button
      {...props}
      className={`${styles.slickPrev} ${styles.slickArrow}` +
      (arrowLocation == "top" ? ` ${styles.topLocation}` : "")
      // +  (currentSlide === 0 ? ` ${styles.slickDisabled}` : "")
    }
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      <i className="bi bi-chevron-left"></i>
    </button>
  )
}

